import MatchTitle from "../items/MatchTitle";
import CustomText from "../CustomText";

import Colors from "../../config/Colors";
import HeaderDropdown from "../HeaderDropdown";
import "react-awesome-button/dist/styles.css";
import Vs from "../../assets/VsWhiteIcon.svg";
import Chevron from "../../assets/ChevronDown.svg";
import { useEffect, useState } from "react";
import moment from "moment";
import { MyRanking, UserPick, UserPicksListResponse } from "../../services";
import {
  GroupedUserPicks,
  groupUserPicks,
  isMobile,
  mapAbbrToLogo,
  mapAbbrToLogoWithURL,
} from "../../types/type";
import {
  formatAnswer,
  formatAnswerCapitalize,
  formatQuestionWording,
} from "../utils";
import { TabContainer } from "./LeaderBoardSegment";
import Point from "../../assets/PointsIcon.svg";
import Rank from "../../assets/RankIcon.svg";
import {
  getCount,
  getRank,
  getTotalPoint,
  getUserData,
} from "../../config/UserStorer";
import Header from "../Header";

interface MyPickProps {
  amount?: string;
  answeredQuestionsWeekly?: number | string;
  pointsRecievedWeekly?: number | string;
  answeredQuestionsSeries?: number | string;
  pointsRecievedSeries?: number | string;
  onWeekly?: () => void;
  data: UserPicksListResponse;
  onSeries?: () => void;
  name?: string;
  setActive: (active: number) => void;
  active?: number;
  myData: MyRanking;
  onPlay?: () => void;
  onShare?: () => void;
  onLogoClick?: () => void;
}

interface ContainerType {
  homeTeamLogo: string;
  awayTeamLogo: string;
  homeTeamAbbr: string;
  awayTeamAbbr: string;
  pickDate: string;
  responses: UserPick[];
  data: UserPick;
}
// interface ResponseType {
//   question: string;
//   yourAnswer: string;
//   actualResult: string;
// }
export function sumArrayValues(array: UserPick[]) {
  let sum = 0;
  for (let i = 0; i < array.length; i++) {
    if (array[i].actual_value !== null) {
      let resp: boolean = array[i].actual_value >= array[i].benchmark_value;

      if (resp === array[i].is_over) {
        sum += 1;
      }
    } else {
    }
  }
  return sum;
}
const Homelogo =
  "https://ssl.gstatic.com/onebox/media/sports/logos/G9q07ZXPVbPkXOagStz3Yw_96x96.png";
export const MatchContainer = ({
  homeTeamLogo,
  homeTeamAbbr,
  awayTeamAbbr,
  awayTeamLogo,
  pickDate,
  responses,
  data,
}: ContainerType) => {
  const totalPoints = sumArrayValues(responses);

  const [visible, setVisible] = useState(!isMobile);
  useEffect(() => {}, []);
  return (
    <div
      onClick={() => setVisible(!visible)}
      style={{
        backgroundColor: "white",
        boxShadow: "0px 5px 20px #eee",
        borderRadius: 10,
        marginTop: "2%",
        width: "90%",
        alignItems: "center",
        cursor: "pointer",
        maxWidth: 700,
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          padding: 10,
          alignContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            textAlign: "left",
            width: "60% !important",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <CustomText
            size={isMobile ? "xxsmall" : "smallMedium"}
            weight={"700"}
            color={Colors.primary}
          >
            {moment(pickDate + "Z").format("MMM DD h:mma")}
          </CustomText>
          {responses[0].actual_value !== null && (
            <CustomText
              size={isMobile ? "xsmall" : "smallMedium"}
              weight={"500"}
              color={Colors.primary}
              marginTop={5}
              style={{
                padding: 3,
                backgroundColor: totalPoints > 0 ? "green" : "#777",
                // backgroundColor: "green",
                borderRadius: 5,
                color: Colors.white,
                width: "fit-content",
              }}
            >
              {totalPoints == 1
                ? "10 Points"
                : totalPoints === 2
                ? "25 Points"
                : totalPoints === 3
                ? "50 Points"
                : "0 Points"}
            </CustomText>
          )}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-evenly",
            alignItems: "center",
          }}
        >
          <div
            style={{
              marginRight: 20,
              alignContent: "center",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: 70,
            }}
          >
            <img
              src={mapAbbrToLogoWithURL(data, false).logo}
              style={{ height: 40, width: 40, objectFit: "contain" }}
              className="otherQuestionChoiceLogo"
              alt={"sunrisers logo"}
            />
            <CustomText
              size="xsmall"
              weight={"500"}
              color={Colors.primary}
              // marginTop={-10}
            >
              {mapAbbrToLogoWithURL(data, false).name}
            </CustomText>
          </div>
          <img
            src={Vs}
            alt="vs"
            className="pageHeaderDropdowIconVs"
            style={{ width: 20 }}
          />
          <div
            style={{
              marginLeft: 20,
              marginRight: isMobile ? 10 : 40,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: isMobile ? 70 : 120,
            }}
          >
            <img
              src={mapAbbrToLogoWithURL(data, true).logo}
              style={{ height: 40, width: 40, objectFit: "contain" }}
              alt={"sunrisers logo"}
              className="otherQuestionChoiceLogo"
            />
            <CustomText
              size="xsmall"
              weight={"500"}
              color={Colors.primary}
              // marginTop={-10}
            >
              {mapAbbrToLogoWithURL(data, true).name}
            </CustomText>
          </div>
          <img
            src={Chevron}
            style={{
              height: isMobile ? 10 : 20,
              width: isMobile ? 10 : 20,
              objectFit: "contain",
              marginRight: isMobile ? 30 : 40,
            }}
            alt={"down"}
            className={visible ? "otherArrow otherUp" : "otherArrow otherDown"}
          />
        </div>
      </div>
      {true && (
        <div
          style={{
            maxHeight: visible ? "500px" : "0px",
            transition: "max-height 0.40s ease-in-out",
            overflow: "hidden",
          }}
        >
          <hr color="#ccc" />
          {responses.map((item: UserPick, index: number) => {
            return (
              <div style={{ padding: 10, paddingTop: 20, textAlign: "left" }}>
                <CustomText weight="600" color={Colors.primary} size={"xsmall"}>
                  Q{index + 1}.
                  {
                    formatQuestionWording({ type: item.question_type_name })
                      .first
                  }{" "}
                  {
                    formatQuestionWording({ type: item.question_type_name })
                      .middle
                  }{" "}
                  {
                    formatQuestionWording({ type: item.question_type_name })
                      .last
                  }
                </CustomText>
                <div
                  style={{ width: "100%", display: "flex", marginTop: "2%" }}
                >
                  <div
                    style={{
                      justifyContent: "center",
                      background: "linear-gradient(45deg,white,#D6DAF2)",
                      width: "50%",
                      padding: 5,
                      marginRight: "0.5%",
                      display: "grid",
                      textAlign: "center",
                      alignItems: "center",
                      placeItems: "center",
                    }}
                  >
                    <CustomText
                      children={"Your Pick"}
                      color={Colors.primary}
                      size={"xsmall"}
                    />
                    {/* this is for the users pick */}
                    {item.question_type_name === "WINNING_TEAM" && (
                      <>
                        {item?.is_over !== null ? (
                          <img
                            src={
                              item.is_over === true
                                ? mapAbbrToLogoWithURL(item, false).logo
                                : item.is_over === false
                                ? mapAbbrToLogoWithURL(item, false).logo
                                : ""
                            }
                            style={{ width: 30 }}
                            alt={""}
                          />
                        ) : (
                          <CustomText
                            children={"Not Answered"}
                            color={Colors.primary}
                            size={"xsmall"}
                            weight={"500"}
                          />
                        )}
                      </>
                    )}
                    {/* this is for the users pick not winning team */}
                    {item.question_type_name !== "WINNING_TEAM" && (
                      <div
                        style={{
                          alignContent: "center",
                          alignItems: "center",
                          display: "flex",
                          textAlign: "right",
                        }}
                      >
                        {item.is_over !== null ? (
                          <CustomText
                            children={
                              formatAnswerCapitalize({
                                question: item,
                                above: item.is_over,
                                isTeam: false,
                              }).buttonText
                            }
                            color={Colors.primary}
                            size={"xsmall"}
                            weight={"700"}
                          />
                        ) : (
                          <CustomText
                            children={"Not Answered"}
                            color={Colors.primary}
                            size={"xsmall"}
                            weight={"500"}
                          />
                        )}
                      </div>
                    )}
                  </div>
                  <div
                    style={{
                      justifyContent: "center",
                      background: "linear-gradient(-45deg,white,#D6DAF2)",
                      width: "50%",
                      marginLeft: "0.5%",
                      padding: 5,
                      display: "grid",
                      textAlign: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "column",
                        justifyContent: "center",
                      }}
                    >
                      {
                        // index === 0 &&
                        <CustomText
                          children={"Actual"}
                          color={Colors.primary}
                          size={"xsmall"}
                        />
                      }
                      {/* this is for actual answer not winning team */}
                      {item.question_type_name !== "WINNING_TEAM" && (
                        <CustomText
                          children={
                            item.actual_value
                              ? formatAnswer({
                                  question: item,
                                  above:
                                    item.actual_value >= item.benchmark_value
                                      ? true
                                      : false,
                                  isTeam: false,
                                  isPlus: true,
                                }).buttonText
                              : "Awaiting Result"
                          }
                          weight="700"
                          color={Colors.primary}
                          size={"xsmall"}
                        />
                      )}
                    </div>
                    {/* this is for actual answer for the winning team */}
                    {item.question_type_name === "WINNING_TEAM" && (
                      <>
                        {item.actual_value === null ? (
                          <CustomText
                            children={"Awaiting Result"}
                            weight="700"
                            color={Colors.primary}
                            size={"xsmall"}
                          />
                        ) : (
                          <img
                            src={
                              item.actual_value > item.benchmark_value
                                ? mapAbbrToLogoWithURL(item, true).logo
                                : mapAbbrToLogoWithURL(item, true).logo
                            }
                            style={{ width: 30 }}
                            alt={""}
                          />
                        )}
                      </>
                    )}
                    {item.question_type_name !== "WINNING_TEAM" && (
                      <div
                        style={{
                          alignContent: "center",
                          alignItems: "center",
                          display: "flex",
                        }}
                      >
                        {/* <CustomText
                          children={
                            item.is_over
                              ? formatAnswer({
                                  question: item,
                                  above:
                                    item.actual_value > item.benchmark_value
                                      ? true
                                      : false,
                                  isTeam: false,
                                  isPlus: true,
                                }).buttonText
                              : "Awaiting Result"
                          }
                          color={Colors.primary}
                          weight={"500"}
                          size={"xsmall"}
                        /> */}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

function MyPickSegment({
  amount,
  answeredQuestionsWeekly,
  pointsRecievedWeekly,
  answeredQuestionsSeries,
  pointsRecievedSeries,
  onSeries,
  onWeekly,
  data,
  name,
  setActive,
  myData,
  active = 1,
  onPlay,
  onShare,
  onLogoClick,
}: MyPickProps) {
  const [tabActive, setTabActive] = useState(active || 1);
  const [filtered] = useState(groupUserPicks(data.user_picks_list));
  const [userData] = useState(getUserData());
  const [totalPoint, setTotalPoint] = useState(0);
  const [weekPoint, setWeekPoint] = useState(0);
  const handleOnSeries = () => {
    if (onSeries) {
      onSeries();
    }
  };

  const handleOnWeekly = () => {
    if (onWeekly) {
      onWeekly();
    }
  };

  const handleTabActive = (tab: number) => {
    setTabActive(tab);
    if (setActive) {
      setActive(tab);
    }
  };

  const handlePlay = () => {
    if (onPlay) {
      onPlay();
    }
  };
  useEffect(() => {
    if (filtered && getTotalPoint()) {
      setTotalPoint(getTotalPoint().total !== null ? getTotalPoint().total : 0);
      setWeekPoint(
        getTotalPoint().weeklytotal !== null ? getTotalPoint().weeklytotal : 0
      );
    }
  }, [filtered]);

  let rankPercent =
    tabActive === 1
      ? percentageCalculator({
          currentRank: myData.accumulated_rank ? myData.accumulated_rank : 0,
          total: getCount().user_count,
        })
      : percentageCalculator({
          currentRank: myData.weekly_rank ? myData.weekly_rank : 0,
          total: getCount().weekly_user_count,
        });
  let points = tabActive === 1 ? myData.accumulated_rank : myData.weekly_rank;

  const handleShare = () => {
    if (onShare) {
      onShare();
    }
  };

  return (
    <div className="relative flexColumn" style={{ alignItems: "center" }}>
      <MatchTitle />
      <Header share={true} onShare={handleShare} />
      <HeaderDropdown onLogoClick={onLogoClick}>
        <CustomText
          size="large"
          weight="400"
          color={Colors.blueLight}
          spacing={5}
          marginTop={40}
          marginBottom={5}
        >
          MY PICKS
        </CustomText>
        <CustomText
          size="medium"
          weight="400"
          color={Colors.brownPrimary}
          marginBottom={10}
        >
          {userData.first_name} {userData.last_name}
        </CustomText>
        <div className="containerStatisticsHeader">
          <div
            className="containerPicksHeaderDropdownPointsContainer"
            onClick={handleOnSeries}
            style={{
              width: "80%",
              justifyContent: "space-between",
              marginBottom: 20,
              marginTop: 20,
            }}
          >
            <div
              style={{
                display: "flex",
                flex: 1,
              }}
            >
              <img
                src={Rank}
                alt=""
                width={33}
                height={33}
                style={{ marginRight: 20 }}
              />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "start",
                  }}
                >
                  <CustomText
                    size="xlarge"
                    weight="800"
                    color={Colors.backgroundPrimary}
                  >
                    {rankPercent}
                  </CustomText>
                  <CustomText
                    size="medium"
                    weight="500"
                    color={Colors.backgroundPrimary}
                    marginLeft={5}
                    marginTop={2}
                  >
                    %
                  </CustomText>
                </div>
                <CustomText size="small" weight="500" color={Colors.blueGray}>
                  Rank
                </CustomText>
              </div>
            </div>
            <div className="containerPicksHeaderDropdownPointsSeparator"></div>
            <div
              style={{
                display: "flex",
                flex: 1,
              }}
            >
              <img
                src={Point}
                alt=""
                width={23}
                height={23}
                style={{ marginRight: 20, marginTop: 5 }}
              />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  flex: 1,
                }}
              >
                <CustomText
                  size="xlarge"
                  weight="800"
                  color={Colors.backgroundPrimary}
                >
                  {tabActive === 1 ? totalPoint : weekPoint}
                </CustomText>
                <CustomText size="small" weight="500" color={Colors.blueGray}>
                  PTS
                </CustomText>
              </div>
            </div>
          </div>
          <TabContainer active={tabActive} onClick={handleTabActive} />
        </div>
      </HeaderDropdown>
      <center style={{ padding: 10 }} className="containerMyPicksMarginBottom">
        {(Object.keys(filtered)?.length === 0 || !Object.keys(filtered)) && (
          <div
            style={{
              marginTop: 20,
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <CustomText
              color={Colors.primary}
              size={isMobile ? "smallMedium" : "large"}
              weight="700"
            >
              No picks submitted
            </CustomText>
            {!isMobile && (
              <CustomText
                color={Colors.blueGray}
                size="mediumLarge"
                weight="500"
                textAlign="center"
                marginTop={20}
                style={{ width: 390 }}
              >
                Check your picks here after you’ve submitted them.
              </CustomText>
            )}
            <div
              className="otherCongraChoiceButton"
              onClick={handlePlay}
              style={{
                marginTop: 30,
                marginBottom: 20,
                width: 167,
                height: 54,
              }}
            >
              <CustomText
                textAlign="center"
                style={{
                  alignItems: "center",
                  display: "flex",
                  justifyContent: "center",
                }}
                spacing={3}
                weight="600"
                color={Colors.primary}
                size={isMobile ? "smallMedium" : "smallMedium"}
              >
                PLAY NOW
              </CustomText>
            </div>
          </div>
        )}
        {Object.keys(filtered).map((matchId: string, index: number) => {
          let dat: UserPick[] = filtered[parseInt(matchId)];

          return (
            <MatchContainer
              homeTeamLogo={dat[0].home_team_abbreviation}
              awayTeamLogo={dat[0].away_team_abbreviation}
              pickDate={dat[0].start_time}
              homeTeamAbbr={dat[0].home_team_abbreviation}
              awayTeamAbbr={dat[0].away_team_abbreviation}
              responses={dat}
              data={dat[0]}
            />
          );
        })}
      </center>
    </div>
  );
}
export const percentageCalculator = ({
  currentRank = 0,
  total = 1,
}: {
  currentRank: number;
  total: number;
}) => {
  console.log("total", total + "s" + currentRank, "some" + currentRank);
  if (total === 0) return 0;
  let mine = (currentRank / total) * 100;
  if (mine === 0) {
    mine = 100;
  } else {
    mine = mine;
  }
  let max_point = 100 - Math.round(mine);
  if (max_point === 100) return 99;
  return max_point;
};

export const calculateTotalPoint = (
  filtered: GroupedUserPicks
): { weeklytotal: number; total: number } => {
  let total = 0;
  let weeklytotal = 0;
  Object.keys(filtered).map((matchId: string, index: number) => {
    let dat: UserPick[] = filtered[parseInt(matchId)];
    let sumvalue = sumArrayValues(filtered[parseInt(matchId)]);
    if (sumvalue === 1) total += 10;
    if (sumvalue === 2) total += 25;
    if (sumvalue === 3) total += 50;
    if (moment().isSame(moment(dat[0].start_time), "isoWeek")) {
      if (sumvalue === 1) weeklytotal += 10;
      if (sumvalue === 2) weeklytotal += 25;
      if (sumvalue === 3) weeklytotal += 50;
    }
  });
  return {
    total: total,
    weeklytotal: weeklytotal,
  };
};
export default MyPickSegment;
